import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Dashboard.css";
import SideNav from "./SideNav";

const HOUSES_API =
  "https://ikaze-thouse-backend.vercel.app/api/houses";

const BOOKINGS_API =
  "https://ikaze-thouse-backend.vercel.app/api/Salebooking";

function RentalManagerDashboard() {
  const [houses, setHouses] = useState([]);
  const [bookings, setBookings] = useState([]);
  
  // PAGINATION STATES
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 3;

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [housesRes, bookingsRes] = await Promise.all([
        axios.get(HOUSES_API),
        axios.get(BOOKINGS_API),
      ]);

      setHouses(housesRes.data || []);
      setBookings(bookingsRes.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // =========================
  // UPDATE STATUS
  // =========================
  const updateBookingStatus = async (id, status) => {
    try {
      await axios.put(`${BOOKINGS_API}/${id}`, { status });

      // refresh data
      fetchDashboardData();

      alert(`Booking ${status} successfully`);
    } catch (error) {
      console.error(error);
      alert(
        error.response?.data?.message ||
          "Failed to update booking status"
      );
    }
  };

  // =========================
  // STATS
  // =========================
  const totalHouses = houses.length;

  const totalValue = houses.reduce(
    (sum, h) => sum + Number(h.price_usd || 0),
    0
  );

  const avgPrice =
    totalHouses > 0 ? totalValue / totalHouses : 0;

  const locations = new Set(
    houses.map((h) => h.location)
  ).size;

  const maxPriceHouse =
    houses.length > 0
      ? houses.reduce((max, h) =>
          Number(h.price_usd || 0) >
          Number(max.price_usd || 0)
            ? h
            : max
        )
      : {};

  const totalBookings = bookings.length;

  const totalSalesValue = bookings.reduce(
    (sum, b) => sum + Number(b.price_usd || 0),
    0
  );

  const approvedBookings = bookings.filter(
    (b) => b.status === "Approved"
  ).length;

  const rejectedBookings = bookings.filter(
    (b) => b.status === "Rejected"
  ).length;

  // =========================
  // PAGINATION LOGIC
  // =========================
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = bookings.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(bookings.length / recordsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <div className="dashboard-wrapper">
      <SideNav />

      <div className="main-content">
        <div className="top-bar">
          <h1>House Sales Dashboard</h1>
          <p>Welcome back Admin 👋</p>
        </div>

        {/* STATS */}
        <div className="stats-container">
          <div className="stat-box blue">
            <h3>Total Houses</h3>
            <p>{totalHouses}</p>
          </div>

          <div className="stat-box green">
            <h3>Total Value</h3>
            <p>${totalValue.toLocaleString()}</p>
          </div>

          <div className="stat-box orange">
            <h3>Average Price</h3>
            <p>${avgPrice.toLocaleString()}</p>
          </div>

          <div className="stat-box purple">
            <h3>Locations</h3>
            <p>{locations}</p>
          </div>

          <div className="stat-box teal">
            <h3>Total Sales</h3>
            <p>${totalSalesValue.toLocaleString()}</p>
          </div>

          <div className="stat-box green">
            <h3>Approved</h3>
            <p>{approvedBookings}</p>
          </div>

          <div className="stat-box red">
            <h3>Rejected</h3>
            <p>{rejectedBookings}</p>
          </div>
        </div>

        {/* TABLE */}
        <div className="recent-section">
          <h2>Recent House Bookings</h2>

          <table className="booking-table">
            <thead>
              <tr>
                <th>Customer</th>
                <th>House</th>
                <th>Phone</th>
                <th>Price</th>
                <th>Booking</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {currentRecords.map((b) => (
                <tr key={b.id}>
                  <td>{b.customer_name}</td>
                  <td>{b.house_title}</td>
                  <td>{b.phone}</td>

                  <td>
                    ${Number(b.price_usd || 0).toLocaleString()}
                  </td>

                  <td>
                    ${Number(b.booking_amount || 0).toLocaleString()}
                  </td>

                  <td>
                    {b.payment_date
                      ? new Date(
                          b.payment_date
                        ).toLocaleDateString("en-GB")
                      : "-"}
                  </td>

                  {/* STATUS FIXED */}
                  <td>                    
                        {b.status} 
                  </td>

                  {/* ACTIONS */}
                  <td>
                    <button
                      className="approve-btn"
                      onClick={() =>
                        updateBookingStatus(
                          b.id,
                          "Approved"
                        )
                      }
                    >
                      Approve
                    </button>

                    <button
                      className="reject-btn"
                      onClick={() =>
                        updateBookingStatus(
                          b.id,
                          "Rejected"
                        )
                      }
                    >
                      Reject
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* PAGINATION CONTROLS */}
          {totalPages > 1 && (
            <div className="pagination-container">
              <button 
                onClick={handlePrevPage} 
                disabled={currentPage === 1}
                className="pagination-btn"
              >
                Previous
              </button>
              <span className="pagination-info">
                Page <strong>{currentPage}</strong> of {totalPages}
              </span>
              <button 
                onClick={handleNextPage} 
                disabled={currentPage === totalPages}
                className="pagination-btn"
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RentalManagerDashboard;